<div class="testcases-container">
    <!-- Loading State -->
    <div class="loading-container" *ngIf="loading">
        <div class="loading-spinner"></div>
        <p>Loading test cases...</p>
    </div>

    <!-- Error State -->
    <div class="error-container" *ngIf="!loading && error">
        <div class="error-icon">⚠️</div>
        <p *ngIf="errorMessage">{{ errorMessage }}</p>
        <p *ngIf="!errorMessage">Failed to load test cases. Please try again.</p>
        <button class="retry-btn" (click)="loadProjectTestCasesData()">Retry</button>
    </div>

    <div class="header-controls" *ngIf="!loading && !error">
        <div style="display: flex; gap: 10px;">
            <mat-checkbox *ngIf="hasAnyPersistedTestcase()" [checked]="isAllSelected()" 
                [indeterminate]="isIndeterminate()" (change)="toggleSelectAll($event.checked)" class="checkbox-txt" [featureActionState]="'TESTCASES'"> Select All
            </mat-checkbox>
            <button class="btn" *ngIf="hasAnyPersistedTestcase()" (click)="runSelectedTestCases()" [featureActionState]="'TESTCASES'"
                [disabled]="selectedIds.size === 0">
                Run Selected
            </button>
            <button class="btn" *ngIf="hasAnyPersistedTestcase()" (click)="deleteSelectedTestCases()" [featureActionState]="'TESTCASES'"
                [disabled]="selectedIds.size === 0">
                Delete Selected
            </button>
            <button class="btn" (click)="addTestCase()" [disabled]="loading || editRow !== null" [featureActionState]="'TESTCASES'">
                Add Test Case
            </button>
        </div>
    </div>

    <!-- Data State -->
    <div *ngIf="!loading && !error">
        <div class="table-container" *ngIf="testAutomationCases.length > 0">
            <table>
                <thead>
                    <tr>
                        <th></th>
                        <th>Test Case ID <span class="required">*</span></th>
                        <th>Description</th>
                        <th>Category</th>
                        <th>Severity</th>
                        <th>Test Steps</th>
                        <th>Test Artifact</th>
                        <th>Test Data</th>
                        <th>Expected Result</th>
                        <th>Application URL</th>
                        <th>Execute</th>
                        <!-- <th>Last Run Status</th> -->
                        <th>Last Run Report</th>
                        <th>Actions</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let row of testAutomationCases; let i = index">
                        <td>
                            <mat-checkbox [checked]="isSelected(row)" [disabled]="!getRowId(row)" [featureActionState]="'TESTCASES'"
                                (change)="toggleSelection(row, $event.checked)"></mat-checkbox>
                        </td>
                        <td>
                            <ng-container *ngIf="editRow === i; else read_caseId">
                                <input required [(ngModel)]="editableRow.test_case_id" #tcid="ngModel" />
                                <div *ngIf="tcid.invalid && tcid.touched" class="error-message">
                                    Test Case ID is required
                                </div>
                            </ng-container>
                            <ng-template #read_caseId>{{ row.test_case_id }}</ng-template>
                        </td>

                        <td>
                            <ng-container *ngIf="editRow === i; else read_description">
                                <input [(ngModel)]="editableRow.description" />
                            </ng-container>
                            <ng-template #read_description>{{ row.description }}</ng-template>
                        </td>

                        <td>
                            <ng-container *ngIf="editRow === i; else read_category">

                                <div class="category-wrapper category-chips-edit" floatLabel="never">
                                        <div class="cat-form" #chipList>
                                            <input #categoryInput
                                                [matAutocomplete]="auto" (keyup)="filterCategories(categoryInput.value)"
                                                (keyup.enter)="addTypedCategory(categoryInput.value)" [ngModel]="null" placeholder="Search category" />
                                            <span><button class="icon-btn refresh-btn" (click)="refreshCategoryList(i)"
                                            title="Refresh Categories">
                                            <mat-icon>refresh</mat-icon>
                                        </button></span>
                                        </div>
                                            <br>
                                        <mat-chip *ngFor="let c of editableRow.category; let idx = index"
                                            [selectable]="false" [multiple]="false" [removable]="true"
                                            (removed)="removeCategory(idx, categoryInput.value)">
                                            {{ c }}
                                            <mat-icon matChipRemove>cancel</mat-icon>
                                        </mat-chip>
                                    <!-- </mat-chip-grid> -->

                                    <mat-autocomplete #auto="matAutocomplete" class="auto-complete"
                                        (optionSelected)="selectCategory($event.option.value)">
                                        <mat-option *ngFor="let c of filteredCategoryList" [value]="c">
                                            {{ c }}
                                        </mat-option>
                                    </mat-autocomplete>

                                </div>

                            </ng-container>
                            
                            <ng-template #read_category>
                                <div class="category-chips">
                                    <mat-chip-list>
                                        <mat-chip *ngFor="let c of row.category">
                                            {{ c }}
                                        </mat-chip>
                                    </mat-chip-list>
                                </div>
                            </ng-template>

                        </td>

                        <td>
                            <ng-container *ngIf="editRow === i; else read_severity">
                                <div class="severity-wrapper">
                                    <select [(ngModel)]="editableRow.severity" class="severity-dropdown">
                                        <option [ngValue]="null">Select</option>

                                        <option *ngFor="let severity of severityList" [ngValue]="severity.value">
                                            {{ severity.name }}
                                        </option>
                                    </select>
                                </div>
                            </ng-container>
                            <ng-template #read_severity class="severity">{{ row.severity }}</ng-template>
                        </td>

                        <td>
                            <ng-container *ngIf="editRow === i; else read_testSteps">
                                <ul cdkDropList (cdkDropListDropped)="dropTestStep($event)" class="step-list">
                                    <li *ngFor="let step of editableRow.test_steps; let j = index; trackBy: trackByIndex"
                                        cdkDrag class="step-item">
                                        <span cdkDragHandle class="drag-handle">
                                            <mat-icon>menu</mat-icon>
                                        </span>
                                        <input #stepInputRef [(ngModel)]="editableRow.test_steps[j]" class="step-input" />
                                        <button class="icon-btn delete-btn" (click)="deleteStep(j)" title="Delete step">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </li>
                                </ul>
                                <!-- Add Step Button -->
                                <button class="add-step-btn" (click)="addStep()">
                                    <mat-icon>add</mat-icon>
                                    Add Step
                                </button>
                            </ng-container>

                            <ng-template #read_testSteps>
                                <ul class="step-list">
                                    <li *ngFor="let step of row.test_steps; let i = index">
                                        {{ i + 1 }}.  <span>{{ step }}</span>
                                    </li>
                                </ul>
                            </ng-template>
                        </td>

                        <td>
                            <ng-container *ngIf="editRow === i; else read_suite">
                                <div class="suite-wrapper">
                                    <select [(ngModel)]="editableRow.suite_id" class="suite-dropdown">
                                        <option [ngValue]="null">Select</option>

                                        <option *ngFor="let suite of suitesList" [ngValue]="suite.value">
                                            {{ suite.name }}
                                        </option>
                                    </select>

                                    <!-- Refresh Icon -->
                                    <button class="icon-btn refresh-btn" (click)="refreshSuiteList()"
                                        title="Refresh Suites">
                                        <mat-icon>refresh</mat-icon>
                                    </button>
                                </div>
                            </ng-container>

                            <ng-template #read_suite>
                                <span>{{ getSuiteName(row.suite_id) || '—' }}</span>
                            </ng-template>
                        </td>

                        <td>
                            <div *ngIf="row.suite_id && row._id" class="test-data-actions">
                                <button class="btn btn-small" (click)="downloadTemplate(row)" matTooltip ="Download Template"><mat-icon>file_download</mat-icon></button>
                                <button class="btn btn-small btn-secondary" (click)="fileInput.click()" matTooltip="Upload
                                    Parameters" [featureActionState]="'TESTCASES'"><mat-icon>upload_file</mat-icon></button>
                                <input type="file" #fileInput accept=".csv" style="display: none"
                                    (change)="onFileSelected($event, row, i, fileInput)" />
                                <button *ngIf="row.dataset_link" class="btn btn-small btn-secondary"
                                    (click)="downloadDataset(row)" matTooltip="Download Dataset"><mat-icon>cloud_download</mat-icon></button>
                            </div>
                        </td>

                        <td>
                            <ng-container *ngIf="editRow === i; else read_expected">
                                <input [(ngModel)]="editableRow.expected_result" />
                            </ng-container>
                            <ng-template #read_expected>{{ row.expected_result }}</ng-template>
                        </td>

                        <td>
                            <ng-container *ngIf="editRow === i; else read_url">
                                <input [(ngModel)]="editableRow.application_url" />
                            </ng-container>
                            <ng-template #read_url>{{ row.application_url }}</ng-template>
                        </td>

                        <td>
                            <!-- <button *ngIf="row.test_script && row.application_url" (click)="runScriptAndRecordTest(i)">
                                Record Test
                            </button>
                            <button *ngIf="!row.test_script && row.application_url" (click)="generateScript(i)">Generate
                                Script</button> -->
                            <button *ngIf="row.suite_id" (click)="runTest(row)" [featureActionState]="'TESTCASES'">Run Test</button>
                        </td>

                        <!-- <td>{{ row.last_run_status }}</td> -->
                        <td>
                            <button *ngIf="row.last_run_report_id" (click)="openReport(row)">
                                View Report
                            </button>
                        </td>
                        <td>
                            <ng-container *ngIf="editRow === i; else actionButtons">
                                <div class="action-buttons-container">
                                    <button class="icon-btn save-btn" (click)="updateTestCase(i)" title="Save changes" [featureActionState]="'TESTCASES'">
                                        <mat-icon>save</mat-icon>
                                        Save
                                    </button>
                                    <button class="icon-btn cancel-btn" (click)="cancelEdit()" title="Cancel editing" [featureActionState]="'TESTCASES'">
                                        <mat-icon>cancel</mat-icon>
                                        Cancel
                                    </button>
                                </div>
                            </ng-container>
                            <ng-template #actionButtons>
                                <div class="action-buttons-container">
                                    <button class="icon-btn edit-btn" (click)="edit(i)" title="Edit test case" [featureActionState]="'TESTCASES'">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                    <button class="icon-btn delete-btn" (click)="deleteTestCase(i)"
                                        title="Delete test case" [featureActionState]="'TESTCASES'">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </ng-template>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- Empty State -->
    <div class="empty-container" *ngIf="!loading && !error && testAutomationCases.length === 0 && selectedProjectId">
        <div class="empty-icon">📋</div>
        <p>No Test Cases found for this issue.</p>
    </div>
</div>